import { useUpdateReturnRequestInCache } from "@babackapp/private-api-client/client/use-invalidate-return-request";
import useUpdateReturnStatus from "@babackapp/private-api-client/client/use-update-return-status";
import type { UpdateReturnRequestStatusDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Truck } from "lucide-react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerHasAtLeastStoreRights } from "@/lib/rights/use-viewer-has-right";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";

export function useMarkAsInTransitAction() {
  const { data: shop } = useCurrentShopSuspense();
  const returnRequest = useCurrentReturnRequest();
  const isApprovedAlready = returnRequest.status.approved.done;
  const isCancelled = returnRequest.status.cancelled.done;
  const t = useTranslation();
  const hasStoreRight = useViewerHasAtLeastStoreRights();
  const updateReturnRequestInCache = useUpdateReturnRequestInCache();
  const { mutate: updateStatusMutation } = useUpdateReturnStatus({
    onSuccess(returnRequest) {
      updateReturnRequestInCache({ returnRequest });
    },
  });

  function updateStatus(status: UpdateReturnRequestStatusDto["status"]) {
    updateStatusMutation({
      params: {
        path: {
          returnRequestId: returnRequest.id,
          shopId: shop.id,
        },
      },
      body: { status },
    });
  }

  return {
    label: t("returnDetail.setAsInTransit"),
    icon: <Truck className="h-5 w-5 text-gray-400" />,
    enabled:
      hasStoreRight &&
      !returnRequest.status.treatedMerchant.done &&
      !isCancelled &&
      isApprovedAlready,
    onClick: () => updateStatus("shipping"),
  };
}
